export class RegularExpressionUtility {
  static escape(value: string): string {
    return value
      .replace(/\\/g, "\\\\")
      .replace(/\./g, "\\.")
      .replace(/\^/g, "\\^")
      .replace(/\$/g, "\\$")
      .replace(/\|/g, "\\|")
      .replace(/\[/g, "\\[")
      .replace(/\]/g, "\\]")
      .replace(/\(/g, "\\(")
      .replace(/\)/g, "\\)")
      .replace(/\{/g, "\\{")
      .replace(/\}/g, "\\}")
      .replace(/\+/g, "\\+")
      .replace(/\*/g, "\\*")
      .replace(/\?/g, "\\?");
  }
}
